module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-0a71352df0ed6ccac401ae7bf01ee0ab.jpg";